import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import CallRecordsResource from 'flow/api/callrecords';
import Actions from 'flow/actions';
import moment from 'moment';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { selectOwnExtensionKey, selectContact } from 'flow/selectors/ExtensionSelectors';
import { getCallRecordActionMarkedAsHandled } from 'flow/utils/call-records-utils';
import { ISO_8601_MS_RESOLUTION } from 'flow/utils';
var ACTION_HANDLE_UNANSWERED = 'handle-unanswered';
var markForQueue = function markForQueue(callRecord, queueKey) {
  return function (dispatch, getState) {
    var state = getState();
    var callRecordKey = callRecord.get('key');
    var ownExtensionKey = selectOwnExtensionKey(state);
    var contact = selectContact(state, ownExtensionKey);
    var bPartNumber = callRecord.getIn(['number', 'number']);
    var callActionDTO = {
      agent: {
        key: ownExtensionKey
      },
      name: ACTION_HANDLE_UNANSWERED,
      timestamp: moment().format(ISO_8601_MS_RESOLUTION)
    };
    CallRecordsResource.createCallAction({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onResult: function onResult(json) {
        json.agent.contact = contact;
        dispatch({
          type: Actions.RESULT_CREATE_CALL_ACTION,
          callRecordKey: callRecordKey,
          queueKey: queueKey,
          bPartNumber: bPartNumber,
          data: json
        });
      },
      onError: networkErrorDispatcher(dispatch)
    }, callRecordKey, callActionDTO);
  };
};
var markForPersonalHistory = function markForPersonalHistory(callRecord) {
  return function (dispatch) {
    var callRecordKey = callRecord.get('key');
    var callActionDTO = {
      name: ACTION_HANDLE_UNANSWERED,
      timestamp: moment().format(ISO_8601_MS_RESOLUTION)
    };
    CallRecordsResource.createCallAction({
      onResult: function onResult(json) {
        dispatch({
          type: Actions.RESULT_CREATE_CALL_ACTION_PERSONAL_CALL,
          callRecordKey: callRecordKey,
          data: json
        });
      },
      onError: networkErrorDispatcher(dispatch)
    }, callRecordKey, callActionDTO);
  };
};
export var markCallRecordHandled = function markCallRecordHandled(callRecord, queueKey) {
  return function (dispatch) {
    if (queueKey) {
      dispatch(markForQueue(callRecord, queueKey));
    } else {
      dispatch(markForPersonalHistory(callRecord));
    }
  };
};
export var unmarkCallRecordHandled = function unmarkCallRecordHandled(callRecord, queueKey) {
  return function (dispatch) {
    var callRecordKey = callRecord.get('key');
    var callAction = getCallRecordActionMarkedAsHandled(callRecord);
    var callActionKey = callAction.get('key');
    CallRecordsResource.deleteCallAction({
      onResult: function onResult() {
        dispatch(_objectSpread({
          type: queueKey ? Actions.RESULT_DELETE_CALL_ACTION : Actions.RESULT_DELETE_CALL_ACTION_PERSONAL_CALL,
          callRecordKey: callRecordKey,
          callActionKey: callActionKey
        }, queueKey && {
          queueKey: queueKey,
          bPartNumber: callRecord.getIn(['number', 'number'])
          // bPartNumber is only used by the pbx-reducer for queue-specific paths today,
          // but could be relevant for personal history (recordsPerNumber) in the future.
        }));
      },
      onError: networkErrorDispatcher(dispatch)
    }, callRecordKey, callActionKey);
  };
};